<template>
  <div class="body">
    <div class="header">
      <el-form :model="accountForm" :inline="true">
        <el-form-item>
          <el-button size="small" type="primary" @click="tohandleEdit">新增</el-button>
          <el-button size="small" type="danger" @click="handleDelete">删除</el-button>
        </el-form-item>
      </el-form>
      <div style="display: flex">
        <el-upload
          class="upload-demo"
          action="#"
          accept="xlsx,xls"
          multiple
          :limit="1"
          :auto-upload="false"
          :with-credentials="false"
          :show-file-list="false"
        >
        <!-- <el-button size="small" type="primary">导入</el-button> -->
        </el-upload>
        <!-- <el-button
          size="small"
          style="margin-left: 10px"
          type="primary"
          @click="exportExcelData"
        >
          导出
        </el-button> -->
      </div>
    </div>
    <div style="margin: 10px">
      <el-table
        :data="conTract"
        stripe
        border
        style="width: 100%"
        :cell-style="styleBack"
        @selection-change="handleSelectionChange"
      >
      <el-table-column
        type="selection"
        align="center"
        width="55"
      ></el-table-column>
      <el-table-column
          prop="schemeName"
          align="center"
          label="雕刻设置名称"
        ></el-table-column>
        <el-table-column
          prop="cuttingNumber"
          align="center"
          label="切断刀编号"
        ></el-table-column>
        <el-table-column
          prop="cuttingDirection"
          align="center"
          label="切断刀雕刻方向"
        >
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.cuttingDirection==='0'">顺时针</el-tag>
          <el-tag type="success" v-if="scope.row.cuttingDirection==='1'">逆时针</el-tag>
      </template>
      </el-table-column>
      
        <el-table-column
          prop="cuttingLoad"
          align="center"
          label="切断刀进给量"
        ></el-table-column>
        <el-table-column
          prop="cuttingKnifez"
          align="center"
          label="切断刀抬刀Z值"
        ></el-table-column>
        <el-table-column
          prop="cuttingCutz"
          align="center"
          label="切断刀下刀Z值"
        ></el-table-column>
        <el-table-column
          prop="cuttingSpeed"
          align="center"
          label="切断刀转速"
        ></el-table-column>
        <el-table-column
          prop="cuttingDiameter"
          align="center"
          label="切断刀直径"
        ></el-table-column>
        <el-table-column
          prop="createTime"
          align="center"
          label="设置时间"
          width="160"
        ></el-table-column>
        <el-table-column label="操作" align="center" width="280">
        <template v-slot="{ row }">
          <el-link type="success" size="small" @click="handleEdit(row)">编辑</el-link>
        </template>
      </el-table-column>
      </el-table>
    </div>



    <el-dialog title="编辑面板雕刻设置" :visible.sync="dialogVisible" width="400px" :close-on-click-modal="false">
      <el-form
        ref="accountForm"
        :model="accountForm"
        label-width="100px"
        class="demo-accountForm"
      >
      <el-form-item label="面板雕刻设置名称" prop="outreachValue">
          <el-input v-model="accountForm.schemeName" type="textarea"></el-input>
        </el-form-item>

   
        <el-form-item label="切断刀编号" prop="outreachValue">
          <el-input v-model="accountForm.cuttingNumber" type="textarea"></el-input>
        </el-form-item>
        <el-form-item style="margin-top: 20px" label="切断刀雕刻方向" prop="remark">
        <el-select clearable size="small" v-model="accountForm.cuttingDirection">
          <el-option
            v-for="item in directionStatus"
            clearable
            :key="item.value"
          :label="item.label"
          :value="item.value"
          />
        </el-select>
      </el-form-item>
        <el-form-item label="切断刀进给量" prop="panelMaterial">
          <el-input v-model="accountForm.cuttingLoad" type="textarea"></el-input>
        </el-form-item>
        <el-form-item label="切断刀抬刀Z值" prop="panelMaterial">
          <el-input v-model="accountForm.cuttingKnifez" type="textarea"></el-input>
        </el-form-item>
        <el-form-item label="切断刀下刀Z值" prop="panelMaterial">
          <el-input v-model="accountForm.cuttingCutz" type="textarea"></el-input>
        </el-form-item>
        <el-form-item label="切断刀转速" prop="panelMaterial">
          <el-input v-model="accountForm.cuttingSpeed" type="textarea"></el-input>
        </el-form-item>
        <el-form-item label="切断刀直径" prop="panelMaterial">
          <el-input v-model="accountForm.cuttingDiameter" type="textarea"></el-input>
        </el-form-item>

        
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="editAccount()">
          确 定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

import {selectStainlessCarvingSet,upDateStainlessCarvingSet,bathDeleteStainlessCarving} from '@/api/set/stainlessSteelCarving'
export default {
  data() {
    return {
    direction: 'rtl',
      pageSize: 10,
      total: 0,
      currentPage: 1,
      multipleSelection: [],
      ids: '',
      drawer: false,
      access: '',
      date: '',
      dialogVisible: false,
      conTract: [],
      directionStatus:[{
      value: '0',
      label: '顺时针'
    }, {
      value: '1',
      label: '逆时针'
    }],
      accountForm: {
        direction:'',
        cuttingDirection:'',
        cuttingNumber: '',
        cuttingLoad: '',
        cuttingKnifez:'',
        cuttingCutz:'',
        cuttingSpeed:'',
        cuttingDiameter:'',
        schemeName:'',
        id:'',
        access:''
      },
      ImpositionFileDTO:{
          startTime: '',
          endTime: '',
          status: '2'
      },
      searchForm: {
        startTime: '',
        secondStartTime: '',
        number: '',
        values: ''
      },
      DeleteDTO:{
        id:'',
      }
    }
  },
  

  mounted() {
    this.access=localStorage.getItem("access")
    this.accountForm.access=localStorage.getItem("access")
    this.getTableData() // 进入页面调用一次获取数据的方法
  },
  methods: {
    styleBack({ row, column, rowIndex, columnIndex }) {
      // if (columnIndex == 0) {
      //   return { color: '#0c87ef' }
      // }
    },
    tohandleEdit(){
      this.accountForm = Object.assign({},this.$options.data().accountForm);
      this.accountForm.access=localStorage.getItem("access")
      this.dialogVisible = true
    },
    getTableData() {
      selectStainlessCarvingSet(this.access).then((res) => {
          console.log(res);
        this.conTract = res.data.data
        console.log(this.conTract )
      //  this.total = Number(res.data.data.total)
      })
    },
    handleEdit(row) {
      this.dialogVisible = true
      if(row){
        this.accountForm=row;
      }
     
    },
    submitForm(accountForm) {
      this.$refs[accountForm].validate((valid) => {
        if (valid) {
          addCarving(this.accountForm).then((res) => {
                if (res.data.msg === '操作成功') {
            this.drawer = false
            this.$message({
              type: 'success',
              message: '添加成功!',
              
            }),
            this.getTableData()
          } else if (res.data.msg !== '操作成功') {
            this.$message({
              type: 'info',
              message: res.data.data
            })
          }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleDelete() {
      if(this.multipleSelection.length==0){
            this.$message({
              type: "error",
              message: "sorry,你还没有勾选任何文件呢!"
            });
            return;
          } 
    this.$confirm('您真的确定要删除吗？\n\n请确认！！！！！', '删除确认', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
          bathDeleteStainlessCarving(this.multipleSelection).then((res) => {
          if (res.data.msg === '操作成功') {
            this.$message({
              type: 'success',
              message: '删除成功!',
            }),
            this.getTableData()

          } else if (res.data.msg !== '操作成功') {
            this.$message({
              type: 'info',
              message: res.data.data
            })
          }
        })
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
  },
   

  
    deleteInfo(){
      bathDeleteFile(this.multipleSelection).then((res) => {
          if(res.data.code===10000){
            this.getTableData()
          }
      })
    },
    //修改
    editAccount() {
      upDateStainlessCarvingSet(this.accountForm).then((res) => {
        if (res.data.msg === '操作成功') {
          this.$message({
            type: 'success',
            message: '保存成功!'
          })
          this.dialogVisible = false
        } else if (res.data.msg !== '操作成功') {
          this.$message({
              type: 'info',
              message: res.data.data
            })
        }
        this.getTableData()
      }
      )
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 导出
    exportExcelData() {
      exportData(this.searchForm, this.currentPage, this.total)
        .then((res) => {
          if (res.status == 200) {
            exportExcel(res.data, res)
            this.$message({
              type: 'success',
              message: '导出成功!'
            })
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    chooeDate(e) {
      // console.log(e)
      if (e) {
        this.ImpositionFileDTO.startTime = e[0]
        this.ImpositionFileDTO.endTime = e[1]
      } else if (!e) {
        this.ImpositionFileDTO.startTime = ''
        this.ImpositionFileDTO.endTime = ''
      }
    },
    // 搜索
    serchInfo() {
      this.getTableData()
    },

  
  }
}
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin: 20px;
}
.body {
  overflow: auto;
}

.pagination {
  margin-top: 10px;
  margin-right: 20px;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  position: relative;
}
.el-pagination ::v-deep.el-pagination__total {
  line-height: 36px;
}
</style>
